import { render, staticRenderFns } from "./TheUserSettings.vue?vue&type=template&id=329359e2&"
import script from "./TheUserSettings.vue?vue&type=script&lang=js&"
export * from "./TheUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports